import React, { useEffect } from 'react';
import _ from 'lodash';
import useFirebase from '../hooks/useFirebase';
import { NotificationManager } from 'react-notifications';

import * as api from '../service/api';

var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();

function userReducer(state, action) {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return { ...state, isAuthenticated: true };
    case 'LOGIN_FAILURE':
      return { ...state, isAuthenticated: false };
    case 'SIGN_OUT_SUCCESS':
      return { ...state, isAuthenticated: false };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function UserProvider({ children }) {
  const firebase = useFirebase();

  var [state, dispatch] = React.useReducer(userReducer, {
    isAuthenticated: -1,
  });

  useEffect(() => {
    return firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        dispatch({ type: 'LOGIN_SUCCESS' });
        // userStorage.set(user && pick(user, "uid", "email", "photoURL"));
        localStorage.setItem('user', JSON.stringify(_.pick(user, 'uid', 'email')));
      } else {
        dispatch({ type: 'LOGIN_FAILURE' });
      }
    });
  }, [firebase]);

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>{children}</UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
}

function useUserState() {
  var context = React.useContext(UserStateContext);
  if (context === undefined) {
    throw new Error('useUserState must be used within a UserProvider');
  }
  return context;
}

function useUserDispatch() {
  var context = React.useContext(UserDispatchContext);
  if (context === undefined) {
    throw new Error('useUserDispatch must be used within a UserProvider');
  }
  return context;
}

export { UserProvider, useUserState, useUserDispatch, loginUser, registerUser, signOut };

// ###########################################################
async function registerUser(
  firebase,
  firestore,
  dispatch,
  firstname,
  lastname,
  email,
  password,
  history,
  setIsLoading,
  setError,
) {
  setError(false);
  setIsLoading(true);

  try {
    const {
      user: { uid },
    } = await firebase.auth().createUserWithEmailAndPassword(email, password);

    await firestore.collection('users').doc(uid).set({
      email,
      firstname,
      lastname,
      emailReminder: true,
      emailStatus: true,
      notificationReminder: true,
      notificationStatus: true,
    });

    dispatch({ type: 'LOGIN_SUCCESS' });
    setError(null);
    setIsLoading(false);
    history.push('/profile');
  } catch (e) {
    console.log('regeister failed', e.message);
    dispatch({ type: 'LOGIN_FAILURE' });
    setError(true);
    setIsLoading(false);

    if (e.message === 'The email address is already in use by another account.') {
      NotificationManager.error(
        'That email address is already in use. You may log in to that account or create a new account with a different email address.',
      );
    } else NotificationManager.error(e.message || 'Something went wrong :(');
  }
}

async function loginUser(firebase, dispatch, history) {
  try {
    const googleProvider = new firebase.auth.GoogleAuthProvider();
    // googleProvider.setCustomParameters({
    //     hd: "dryftwell.com"
    // });

    const result = await firebase.auth().signInWithPopup(googleProvider);

    console.log(result);

    const userId = _.get(result, 'user.uid');
    const user = _.get(result, 'user');

    // localStorage.setItem('user', JSON.stringify(user));

    await api.login(userId, user.email);

    dispatch({ type: 'LOGIN_SUCCESS' });
    history.push('/dashboard');
  } catch (e) {
    console.log(e);
    dispatch({ type: 'LOGIN_FAILURE' });
    NotificationManager.error(e.message || 'Something went wrong :(');
  }
}

async function signOut(firebase, dispatch, history) {
  firebase.auth().signOut();
  dispatch({ type: 'SIGN_OUT_SUCCESS' });
  history.push('/');
}
